import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';
import {WEEKDAYS_SHORT} from '../../i18n/timeLocaleData';

const styles = {
  wrapper: {
    padding: 15
  },
};

@injectIntl
class ScoreByDayOfWeekBarChart extends Component {
  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const scoreByDayOfWeek = answersReport ? answersReport.scoreByDayOfWeek : [];

    const categories = scoreByDayOfWeek.map(item => {
      return WEEKDAYS_SHORT[intl.locale][item.dayOfWeek%7];
    });
    const data = scoreByDayOfWeek.map(item => item.score);

    const chartConfig = {
      chart: {
        type: 'column',
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
        marginLeft: 20,
        marginRight: 20,
      },
      title: {
        text: intl.formatMessage({id: 'score'}),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          },{
            count: scoreByDayOfWeek[index].count,
          });
        },
      },
      xAxis: {
        categories,
        title: {
          text: intl.formatMessage({id: 'dayOfWeek'}),
        },
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            format: '{y:.1f}',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  ScoreByDayOfWeekBarChart,
  graphql`
    fragment ScoreByDayOfWeekBarChart_answersReport on AnswersReport {
      scoreByDayOfWeek {
        dayOfWeek
        score
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/ScoreByDayOfWeekBarChart/ScoreByDayOfWeekBarChart.js